export default {"src":"/_next/static/media/icon-dislike.c38d0278.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};